// Auto-generated by backend/generate_belajar.py — 11-language labels for /belajar.
export const BELAJAR_UI = {
  "pageTitle": {
    "id": "Belajar Manasik",
    "en": "Learn Manasik",
    "ar": "تعلَّم المناسك",
    "fr": "Apprendre les Manasik",
    "de": "Manasik Lernen",
    "es": "Aprender Manasik",
    "ru": "Изучение Манасик",
    "zh": "学习朝觐礼仪",
    "ja": "マナーシクを学ぶ",
    "ko": "마나식 배우기",
    "hi": "मनासिक सीखें"
  },
  "pageSub": {
    "id": "Pelajari tata cara ibadah umrah dan haji secara terpisah, langkah demi langkah.",
    "en": "Learn the rituals of Umrah and Hajj separately, step by step.",
    "ar": "تعلَّم إجراءات العبادة في العمرة والحج بشكل منفصل، خطوة بخطوة.",
    "fr": "Apprenez les rites de la Umrah et du Hajj séparément, étape par étape.",
    "de": "Lernen Sie die Rituale der Umrah und Hadsch separat, Schritt für Schritt.",
    "es": "Aprenda los ritos de la Umrah y el Hajj por separado, paso a paso.",
    "ru": "Изучайте обряды Умры и Хаджа по отдельности, шаг за шагом.",
    "zh": "分别逐步学习副朝（Umrah）和正朝（Hajj）的礼仪。",
    "ja": "ウムラとハッジの礼拝の作法をそれぞれ、ステップごとに学びましょう。",
    "ko": "우므라와 하즈의 예배 절차를 각각 단계별로 배워보세요.",
    "hi": "उमरह और हज की इबादत के तरीके को अलग-अलग, कदम दर कदम सीखें।"
  },
  "learnUmrah": {
    "id": "Belajar Umrah",
    "en": "Learn Umrah",
    "ar": "تعلَّم العمرة",
    "fr": "Apprendre la Umrah",
    "de": "Umrah Lernen",
    "es": "Aprender Umrah",
    "ru": "Изучить Умру",
    "zh": "学习副朝（Umrah）",
    "ja": "ウムラを学ぶ",
    "ko": "우므라 배우기",
    "hi": "उमरह सीखें"
  },
  "learnHajj": {
    "id": "Belajar Haji",
    "en": "Learn Hajj",
    "ar": "تعلَّم الحج",
    "fr": "Apprendre le Hajj",
    "de": "Hadsch Lernen",
    "es": "Aprender Hajj",
    "ru": "Изучить Хадж",
    "zh": "学习正朝（Hajj）",
    "ja": "ハッジを学ぶ",
    "ko": "하즈 배우기",
    "hi": "हज सीखें"
  },
  "umrahDesc": {
    "id": "Rangkaian lengkap ibadah umrah",
    "en": "The complete series of Umrah rituals",
    "ar": "السلسلة الكاملة لمناسك العمرة",
    "fr": "La série complète des rites de la Umrah",
    "de": "Die vollständige Abfolge der Umrah-Rituale",
    "es": "La serie completa de los ritos de la Umrah",
    "ru": "Полный порядок обрядов Умры",
    "zh": "副朝（Umrah）全套礼仪流程",
    "ja": "ウムラの礼拝の完全な一連の流れ",
    "ko": "우므라 예배의 완전한 순서",
    "hi": "उमरह की इबादत का पूरा क्रम"
  },
  "hajjDesc": {
    "id": "Rangkaian lengkap ibadah haji",
    "en": "The complete series of Hajj rituals",
    "ar": "السلسلة الكاملة لمناسك الحج",
    "fr": "La série complète des rites du Hajj",
    "de": "Die vollständige Abfolge der Hadsch-Rituale",
    "es": "La serie completa de los ritos del Hajj",
    "ru": "Полный порядок обрядов Хаджа",
    "zh": "正朝（Hajj）全套礼仪流程",
    "ja": "ハッジの礼拝の完全な一連の流れ",
    "ko": "하즈 예배의 완전한 순서",
    "hi": "हज की इबादत का पूरा क्रम"
  },
  "learnMore": {
    "id": "Pelajari selengkapnya",
    "en": "Learn More",
    "ar": "اعرف المزيد",
    "fr": "En savoir plus",
    "de": "Mehr erfahren",
    "es": "Aprender más",
    "ru": "Узнать больше",
    "zh": "了解更多",
    "ja": "詳細を見る",
    "ko": "더 알아보기",
    "hi": "और जानें"
  },
  "stepsLabel": {
    "id": "langkah",
    "en": "step",
    "ar": "خطوة",
    "fr": "étape",
    "de": "Schritt",
    "es": "paso",
    "ru": "шаг",
    "zh": "步骤",
    "ja": "ステップ",
    "ko": "단계",
    "hi": "चरण"
  },
  "dashLabel": {
    "id": "Belajar Umrah & Haji",
    "en": "Learn Umrah & Hajj",
    "ar": "تعلّم العمرة والحج",
    "fr": "Apprendre l'Umrah & le Hajj",
    "de": "Umrah & Hajj lernen",
    "es": "Aprender Umrah y Hajj",
    "ru": "Учиться Умре и Хаджу",
    "zh": "学习乌姆拉与朝觐",
    "ja": "ウムラとハッジを学ぶ",
    "ko": "우므라 & 하지 배우기",
    "hi": "उमरह और हज सीखें"
  },
  "dashHint": {
    "id": "Tata cara umrah & haji dipisah, langkah demi langkah",
    "en": "Umrah & Hajj procedures are separated, step by step",
    "ar": "إجراءات العمرة والحج مفصّلة خطوة بخطوة",
    "fr": "Les procédures de l'Umrah et du Hajj sont séparées, étape par étape",
    "de": "Umrah- und Hajj-Abläufe sind getrennt, Schritt für Schritt",
    "es": "Los procedimientos de Umrah y Hajj están separados, paso a paso",
    "ru": "Порядок выполнения Умры и Хаджа разделён пошагово",
    "zh": "乌姆拉与朝觐程序分开，逐步说明",
    "ja": "ウムラとハッジの手順を分けて、ステップごとに解説",
    "ko": "우므라와 하지 절차를 분리하여 단계별로 안내",
    "hi": "उमरह और हज की प्रक्रियाएं अलग-अलग, कदम दर कदम"
  },
  "openGuide": {
    "id": "Buka Panduan Lengkap",
    "en": "Open Complete Guide",
    "ar": "افتح الدليل الشامل",
    "fr": "Ouvrir le guide complet",
    "de": "Vollständigen Leitfaden öffnen",
    "es": "Abrir guía completa",
    "ru": "Открыть полное руководство",
    "zh": "打开完整指南",
    "ja": "完全ガイドを開く",
    "ko": "전체 가이드 열기",
    "hi": "पूर्ण गाइड खोलें"
  },
  "badgeTitle": {
    "id": "Lencana Belajar",
    "en": "Learning Badge",
    "ar": "شارة التعلّم",
    "fr": "Badge d'apprentissage",
    "de": "Lernabzeichen",
    "es": "Insignia de aprendizaje",
    "ru": "Значок обучения",
    "zh": "学习徽章",
    "ja": "学習バッジ",
    "ko": "학습 배지",
    "hi": "सीखने का बैज"
  },
  "badgeComplete": {
    "id": "Selamat! Anda telah menuntaskan jalur ini.",
    "en": "Congratulations! You have completed this path.",
    "ar": "مبروك! لقد أتممتَ هذا المسار.",
    "fr": "Félicitations ! Vous avez complété ce parcours.",
    "de": "Herzlichen Glückwunsch! Sie haben diesen Pfad abgeschlossen.",
    "es": "¡Felicitaciones! Has completado este recorrido.",
    "ru": "Поздравляем! Вы завершили этот путь.",
    "zh": "恭喜！您已完成此学习路径。",
    "ja": "おめでとうございます！このコースを修了しました。",
    "ko": "축하합니다! 이 과정을 완료하였습니다.",
    "hi": "मुबारक हो! आपने यह मार्ग पूरा कर लिया है।"
  },
  "badge100": {
    "id": "100% Selesai",
    "en": "100% Complete",
    "ar": "مكتمل ١٠٠٪",
    "fr": "100 % Complété",
    "de": "100 % Abgeschlossen",
    "es": "100 % Completado",
    "ru": "100% Завершено",
    "zh": "100% 完成",
    "ja": "100% 修了",
    "ko": "100% 완료",
    "hi": "१००% पूर्ण"
  },
  "badgeShare": {
    "id": "Bagikan Lencana",
    "en": "Share Badge",
    "ar": "شارك الشارة",
    "fr": "Partager l'insigne",
    "de": "Abzeichen teilen",
    "es": "Compartir insignia",
    "ru": "Поделиться значком",
    "zh": "分享徽章",
    "ja": "バッジをシェアする",
    "ko": "배지 공유하기",
    "hi": "बैज साझा करें"
  },
  "badgeCertified": {
    "id": "Telah menuntaskan pembelajaran",
    "en": "Has completed the learning journey",
    "ar": "أتمَّ مسيرة التعلُّم",
    "fr": "A complété le parcours d'apprentissage",
    "de": "Hat den Lernpfad abgeschlossen",
    "es": "Ha completado el recorrido de aprendizaje",
    "ru": "Завершил путь обучения",
    "zh": "已完成学习历程",
    "ja": "学習コースを修了しました",
    "ko": "학습 과정을 완료하였습니다",
    "hi": "शिक्षण यात्रा पूर्ण की है"
  }
};
